import DownloadSurveyModal from './modals/DownloadSurveyModal';

export default {
  DOWNLOAD_SURVEY_MODAL: DownloadSurveyModal,
};
